import type { TrainingStatus, TrainingType } from './types';

const TRAINING_STATUS_LABELS: Record<TrainingStatus, string> = {
  planificada: 'Planificada',
  en_curso: 'En curso',
  completada: 'Completada',
  cancelada: 'Cancelada',
};

const TRAINING_TYPE_LABELS: Record<TrainingType, string> = {
  interna: 'Interna',
  externa: 'Externa',
};

export function labelTrainingStatus(status: TrainingStatus): string {
  return TRAINING_STATUS_LABELS[status] ?? status;
}

export function labelTrainingType(type: TrainingType): string {
  return TRAINING_TYPE_LABELS[type] ?? type;
}

export function trainingStatusBadgeClass(status: TrainingStatus): string {
  switch (status) {
    case 'completada':
      return 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300';
    case 'en_curso':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300';
    case 'cancelada':
      return 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300';
    default:
      return 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300';
  }
}

export function formatCompetencies(items: { name: string; level: number }[] | null | undefined): string {
  if (!items?.length) return '—';
  return items.map((item) => `${item.name} (nivel ${item.level})`).join(', ');
}
